function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FormHelperText, InputLabel, makeStyles } from '@material-ui/core';
import { Rating as MUIRating } from '@material-ui/lab';
import useFormHelpers from '../../hooks/useFormHelpers';
const useStyles = makeStyles(theme => ({
  error: {
    color: theme.palette.error[500]
  },
  formHelperText: {
    margin: 0
  },
  label: {
    marginBottom: theme.spacing(1)
  }
}));

const Rating = ({
  error,
  helperText,
  label,
  onChange,
  ...props
}) => {
  const classes = useStyles();
  return React.createElement(React.Fragment, null, label && React.createElement(InputLabel, {
    error: error,
    className: classes.label
  }, label), React.createElement(MUIRating, _extends({
    onChange: (event, value) => onChange(value)
  }, props)), helperText && React.createElement(FormHelperText, {
    className: classes.formHelperText,
    error: error
  }, helperText));
};

Rating.propTypes = {
  error: PropTypes.bool,
  helperText: PropTypes.string,
  label: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.number
};
Rating.defaultProps = {
  onChange: () => ''
};

const LinkedRating = props => {
  const {
    value,
    ...helpers
  } = useFormHelpers(props);
  return React.createElement(Rating, _extends({
    value: value || 0
  }, helpers));
};

LinkedRating.propTypes = {
  name: PropTypes.string.isRequired
};
export { Rating, LinkedRating };